import { com, kotlin } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import requireValidPaginationParameters from '../common/requireValidPaginationParameters'
import permissionGrantDTO, { PermissionGrantDTO } from '../../../../domain/permission/PermissionGrantDTO'
import requireAuthContext from '../../authorization/requireAuthContext'
import KtList = kotlin.collections.KtList
import IndexedPaginatedResponse = com.eidu.api.pagination.IndexedPaginatedResponse

export type GetPermissionGrantsParameters = { pageIndex: number; pageSize: number }

const getPermissionGrants = async ({
  pageIndex,
  pageSize,
}: GetPermissionGrantsParameters): Promise<IndexedPaginatedResponse<PermissionGrantDTO>> => {
  requireValidPaginationParameters(pageIndex, pageSize)
  const authContext = await requireAuthContext()

  const response = await fetch(
    `${entityApiUrl}/organizations/${authContext.organizationId}/permissions/grants?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    {
      headers: {
        Authorization: `Bearer ${authContext.accessToken}`,
        Accept: 'application/json',
      },
    }
  )
  if (response.status !== 200)
    throw Error(`Unexpected response code ${response.status} from getPermissionGrants endpoint`)
  const { documents, totalCount } = await response.json()
  const permissionGrants = documents.map(permissionGrantDTO)
  return new IndexedPaginatedResponse(KtList.fromJsArray(permissionGrants), totalCount)
}

export default getPermissionGrants
